import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import "./GlobalEntityList.css";

import GlobalEntityList_0 from './EntityTypeList/GlobalEntityList_0';
import GlobalEntityList_1 from './EntityTypeList/GlobalEntityList_1';
import GlobalEntityList_2 from './EntityTypeList/GlobalEntityList_2';
import GlobalEntityList_3 from './EntityTypeList/GlobalEntityList_3';

// import Entity from './Entity';

class EntityList extends Component {

	static defaultProps = {
		updateEntityList : () => {
			console.error("EntityList.updateEntityList props is ", null, " or ", undefined);
		},
		updateEntityDetail : () => {
			console.error("EntityList.updateEntityDetail props is ", null, " or ", undefined);
		},
		registUpdateEntity : () => {
			console.error("EntityList.registUpdateEntity props is ", null, " or ", undefined);
		},
		selectedEntityType : 0,
		typeEntityObject : {},
		disableTypes : [], // selectBox에서 보여주지 않을 type 배열
		importEntity : () => { // 엔티티 import action
			console.error("importEntity ", null, undefined);
		},
		showImportBtn : false, // 엔티티 import btn 보여줄지 여부
	}

	state = {
		selectedEntityType : 0,
	}

	allowedTypes = [0, 1, 2, 3]

	handleTypeOnChanged = (e) => {
		let { value } = e.target;
		
		if (typeof value !== 'number') {
			try {
				value = parseInt(value);
			} catch (e) {
				alert('엔티티 타입 to int parse 예외 처리');
				
			}
		}

		if (this.props.isForInstance) {
			this.setState({
				selectedEntityType : value,
			})
		} else {
			this.setEntityTypeSelection(value);
		}
	}

	handleClickAddEntityBtn = (e) => {
		this.props.showCreateEntityModal();
	}

	deleteEntity = (type, id) => {
		this.props.deleteEntity(type, id);
	}

	setEntityTypeSelection = (value) => {
		this.setState({
			selectedEntityType : value,
		})
	}

	render() {

		const renderEntityOptions = () => {
			const renderedOptions = [];
			this.allowedTypes.map( (type, i) => {
				if (this.props.disableTypes.find( disableType => disableType === type)) { // props.disableTypes는 랜더링 하지 않음
					return;
				}
				if ( type === this.state.selectedEntityType ) {
					renderedOptions.push(<option value={type} selected> {numberTypeToString(type)} </option>);
				} else {
					renderedOptions.push(<option value={type}> {numberTypeToString(type)} </option>);
				}
			})
			return renderedOptions
		};

		const renderListContent = () => {
			const {topicId} = this.props;
			const {updateEntityList} = this.props;
			const {typeEntityObject} = this.props;

			switch(this.state.selectedEntityType) {
				case 0:
					return (
						<GlobalEntityList_0
							showImportBtn={this.props.showImportBtn}
							importEntity={this.props.importEntity}
							importEntityList={this.props.importEntityList} />
					)

				case 1:
					return (
						<GlobalEntityList_1
							showImportBtn={this.props.showImportBtn}
							importEntity={this.props.importEntity}
							importEntityList={this.props.importEntityList} />
					)

				case 2:
					return (
						<GlobalEntityList_2
							showImportBtn={this.props.showImportBtn}
							importEntity={this.props.importEntity}
							importEntityList={this.props.importEntityList} />
					)
				case 3:
					return (
						<GlobalEntityList_3 />
					)

				default:
				alert("잘못된 엔티티 타입 입니다.");
			}
		}

		return (
			<div className="entity-list">
				<div className="entity-stack-wrapper">
					<div className="option-bar-area entity-list-options">
						{/* {
							!this.props.isForInstance && (
								<button className="btn btn-success entity-option-btn create-entity-btn"
									onClick={this.handleClickAddEntityBtn} >
									<FontAwesomeIcon icon={faPlus} />
								</button>
							)
						} */}
						
						<select className="entity-type-select"
							onChange={this.handleTypeOnChanged}>
							{renderEntityOptions()}
						</select>

					</div>
					<div className="entity-stack">
						{renderListContent()}
					</div>
				</div>   
			</div>
    );
	}
}

const NotExistEntity = () => {
	return (
		<div className="not-exist-entity">
			<p> 엔티티가 존재하지 않습니다. </p>
		</div>
	);
}

const numberTypeToString = (type) => {
	switch(type) {
		case 0:
		return "사전 엔티티"
		break;
		
		case 1:
		return "정규식 엔티티"
		break;

		case 2:
		return "함수식 엔티티"
		break;
		
		case 3:
		return "그룹 엔티티"
		break;

		default:
		return "UNDEFINED"

	}
}

export default EntityList;